import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function setExternalTrainingModuleDraftImport(
   moduleid: number,
   importid: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('put', `/external_training_modules/${moduleid}/draft`, {
      ...common,
      body: {
         importid,
      },
   });
}
